import gql from 'graphql-tag';

export default gql`
  query LatestTheaters($limit: Int) {
    latestTheaters(limit: $limit) {
      premium {
        id
        plan
        slug
        name
        address
        website
        city
        facebook
        country
        active
        images {
          url
        }
      }
      free {
        id
        plan
        slug
        name
        address
        website
        city
        facebook
        country
        active
        images {
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/LatestTheaters.js